const line = {
  state: {
    lineListEnum: [],
    lineListNewEnum: [],
    lineListTreeEnum: [],
  },

  mutations: {
    SET_LINE_LIST: (state, data) => {
      state.lineListEnum = data
    },
    SET_LINE_LIST_NEW: (state, data) => {
      state.lineListNewEnum = data
    },
    SET_LINE_LIST_TREE: (state, data) => {
      state.lineListTreeEnum = data
    },
  },

  actions: {
    // 业务线
    set_line_list({ commit }, data) {
      commit('SET_LINE_LIST', data)
    },
    // 业务线-新
    set_line_list_new({ commit }, data) {
      commit('SET_LINE_LIST_NEW', data)
    },
    // 业务线-树形
    set_line_list_tree({ commit }, data) {
      commit('SET_LINE_LIST_TREE', data)
    },
  }
}

export default line
